import React, { Component } from "react";
import { connect } from "react-redux";
import AlertCardTelemetry from "../AlertCardTelemetry";
import FontAwesome from "react-fontawesome";
import Moment from "react-moment";
import "./index.css";
import { Checkbox, Row, Col } from "react-bootstrap";

class AlertCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTelemetry: false,
      selectedAlert: false,
      action: null
    };
  }

  componentDidMount = () => {
    this.setState(() => {
      return {
        selectedAlert: this.props.selectedAlert,
        action: this.props.action
      };
    });
  };

  componentWillReceiveProps = nextProps => {
    this.setState(() => {
      return {
        selectedAlert: nextProps.selectedAlert,
        action: nextProps.action
      };
    });
  };

  selectAlert = e => {
    this.state.action(parseInt(e.target.value, 10));
  };

  getPrecincts = precincts => {
    if (precincts.length === 0) {
      return "-";
    }
    return (
      <span>
        {precincts.map(function(item, i) {
          return (
            <span key={i}>
              {i > 0 ? ", " : null}
              {item.name}
            </span>
          );
        })}
      </span>
    );
  };

  getNumberOfHours = (startDate, endDate) => {
    const diffHours = Math.round((endDate.getTime() - startDate.getTime()) / 3600000);
    return diffHours;
  };

  getNumberOfSeconds = (startDate, endDate) => {
    const diffSeconds = Math.round((endDate.getTime() - startDate.getTime()) / 1000);
    return diffSeconds;
  };

  getNumberOfMinutes = (startDate, endDate) => {
    const diffMinutes = Math.round((endDate.getTime() - startDate.getTime()) / 60000);
    return diffMinutes;
  };

  getTimeDifference = (startTime, endTime) => {
    if (startTime === undefined || endTime === undefined) {
      return "-";
    }

    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    let timeDifference = "";

    const tempHours = this.getNumberOfHours(startDate, endDate);
    if (tempHours < 1) {
      const tempMins = this.getNumberOfMinutes(startDate, endDate);
      if (tempMins < 1) {
        const tempSecs = this.getNumberOfSeconds(startDate, endDate);
        timeDifference = tempSecs + (tempSecs > 1 ? " secs" : " sec");
      } else {
        timeDifference = tempMins + (tempMins > 1 ? " mins" : " min");
      }
    } else {
      timeDifference = tempHours + (tempHours > 1 ? " hours" : " hour");
    }
    return timeDifference;
  };

  capitalize = status => {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  showGraphPanel = () => {
    this.toggleGraphPanel(true);
  };

  toggleGraphPanel = toggleValue => {
    this.setState({
      showTelemetry: toggleValue
    });
  };

  renderTitleRow = item => {
    return (
      <div className="row-title">
        <FontAwesome className={"icon-tab severity-" + item.alert_type.severity} name={this.renderSeverityIcon(item)} />
        {item.alert_type.name} <span>(ID: {item.id})</span>{" "}
      </div>
    );
  };

  renderSeverityIcon = item => {
    if (item.alert_type.severity === "reportable") {
      return "exclamation-triangle";
    } else if (item.alert_type.severity === "critical") {
      return "exclamation-circle";
    } else if (item.alert_type.severity === "warning") {
      return "exclamation-triangle";
    } else if (item.alert_type.severity === "info") {
      return "bell";
    } else {
      return "bell";
    }
  };

  renderStatus = item => {
    // Unmonitored locations shouldn't have a status displayed at all
    if (item.closed) {
      return "";
    } else {
      return (
        <div className="alert-status">
          <FontAwesome className="icon-tab fa-xs status-icon-ongoing" name="circle" />
          <span className="status-ongoing">Ongoing</span>
        </div>
      );
    }
  };

  renderStartTime = item => {
    if (!item.telemetry_start_time) {
      return "-";
    } else {
      return <Moment format="DD MMM YYYY hh:mma">{item.telemetry_start_time}</Moment>;
    }
  };

  renderEndTime = item => {
    if (!item.closed || !item.telemetry_end_time) {
      return "-";
    } else {
      return <Moment format="DD MMM YYYY hh:mma">{item.telemetry_end_time}</Moment>;
    }
  };

  renderDeviceName = item => {
    if (!item.devices[0]) {
      return "-";
    } else {
      return item.devices[0].name;
    }
  };

  renderDeviceType = item => {
    if (!item.devices[0]) {
      return "-";
    } else {
      return item.devices[0].device_type_display;
    }
  };

  renderShowTelemetryLink = item => {
    if (!item.telemetry_sets[0]) {
      return "";
    } else {
      return (
        <a className="link" role="button" onClick={this.showGraphPanel}>
          Show Telemetry
        </a>
      );
    }
  };

  renderSecondRow = item => {
    return (
      <Row>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Device</span>
              <span className="card-datum-value">{this.renderDeviceName(item)}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Severity</span>
              <span className="card-datum-value">{this.capitalize(item.alert_type.severity)}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Precincts</span>
              <span className="card-datum-value">{this.getPrecincts(item.precincts)}</span>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  renderThirdRow = item => {
    return (
      <Row>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Start Time</span>
              <span className="card-datum-value">{this.renderStartTime(item)}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">End Time</span>
              <span className="card-datum-value">{this.renderEndTime(item)}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Duration</span>
              <span className="card-datum-value">
                {this.getTimeDifference(item.telemetry_start_time, item.telemetry_end_time)}
              </span>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  render = () => {
    const { item } = this.props;

    if (!item) {
      return null;
    }

    return (
      <div className="mainAlertPanel">
        <div className="alertPanel">
          <div className="checkbox-column">
            <Checkbox
              name="status"
              className="styled-checkbox"
              checked={this.state.selectedAlert}
              onClick={this.selectAlert}
              value={item.id}
            >
              <span className="checkmark" />
            </Checkbox>
          </div>
          <div className="content-column">
            <div>
              {this.renderTitleRow(item)}
              {this.renderStatus(item)}
              {this.renderSecondRow(item)}
              {this.renderThirdRow(item)}
            </div>
          </div>
          <div className="action-column">{this.renderShowTelemetryLink(item)}</div>
          <AlertCardTelemetry
            source={"alertPanel"}
            togglePanel={this.toggleGraphPanel}
            show={this.state.showTelemetry}
            alert={item}
          />
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(AlertCard);



// WEBPACK FOOTER //
// ./src/_components/AlertCard/index.js